import { ThemeContainer, ThemeProvider } from "@dropbox/dig-foundations";
import { ChatPageWrapper } from "@mirage/mosaics/Chat/components/layouts/ChatPageLayout";
import { SourcesCacheProvider } from "@mirage/mosaics/ComposeAssistant/components/workflow-agent/SourcesCacheContext";
import { AssistTemplatesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/AssistTemplatesContext";
import { ComposeAnalyticsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeAnalyticsContext";
import { ComposeSessionsContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeSessionsContext";
import { ComposeVoicesContextProvider } from "@mirage/mosaics/ComposeAssistant/data/ComposeVoicesContext";
import { ComposeCurrentSessionContextProvider } from "@mirage/mosaics/ComposeAssistant/data/current-session/ComposeCurrentSessionContext";
import { useConversationEventOrchestrator } from "@mirage/mosaics/ConversationAssistant/hooks/useConversationEventOrchestrator";
import type { ConversationRouterState } from "@mirage/service-conversation/router_state_types";
import { readyPage } from "@mirage/service-fss-bridge";
import { useFssTheme } from "@mirage/service-fss-bridge/hooks/fssTheme";
import { useMountEffect } from "@react-hookz/web";
import { useCallback, useRef } from "react";
import { ConversationAssistantPageContent } from "./ConversationAssistantPageContent";

export const EmbedChatPage: React.FC = () => {
  const { isDarkMode } = useFssTheme();
  const createNewSession = useRef<
    (routerState?: ConversationRouterState) => void
  >(() => {});

  const onRequestNewSession = useCallback(
    (routerState?: ConversationRouterState) => {
      createNewSession.current(routerState);
    },
    [],
  );

  useConversationEventOrchestrator({
    onRequestNewSession,
  });

  useMountEffect(() => {
    readyPage();
  });

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ComposeSessionsContextProvider>
        <ComposeAnalyticsContextProvider>
          <ComposeVoicesContextProvider>
            <AssistTemplatesContextProvider>
              <ChatPageWrapper>
                <ComposeCurrentSessionContextProvider>
                  <SourcesCacheProvider>
                    <ThemeProvider mode={isDarkMode ? "dark" : "bright"}>
                      <ThemeContainer>
                        <ConversationAssistantPageContent
                          showModelPickerButton={false}
                          showIncognitoButton={false}
                          onRequestNewSession={(handler) =>
                            (createNewSession.current = handler)
                          }
                        />
                      </ThemeContainer>
                    </ThemeProvider>
                  </SourcesCacheProvider>
                </ComposeCurrentSessionContextProvider>
              </ChatPageWrapper>
            </AssistTemplatesContextProvider>
          </ComposeVoicesContextProvider>
        </ComposeAnalyticsContextProvider>
      </ComposeSessionsContextProvider>
    </div>
  );
};
